import { useSelector } from 'react-redux';
import { formatMoney } from '../utils';
import { getApiVersion } from '../selectors';
import { FeesAction } from '../type/enums';

enum PayeeType {
    INTERNAL = 'internal',
    EXTERNAL = 'external',
}

const isValidFeesAction = (action: any): action is FeesAction => {
    return Object.values(FeesAction).includes(action);
};

const useTranslatedFeePrompt = (
    translate,
    action,
    fee,
    standingOrderRecurranceFee,
    productType,
    isInternalPayee
) => {
    const isTribe = useSelector(getApiVersion) === '/v2';

    const getStandingOrderFeeTranslateKey = () => {
        const payeeType = isInternalPayee ? PayeeType.INTERNAL : PayeeType.EXTERNAL;
        return isTribe ? `${action}.tribe.${payeeType}` : `${action}.eps.${payeeType}`;
    };

    const defaultParams = {
        action,
        fee: formatMoney(fee),
    };

    if (!isValidFeesAction(action)) {
        return translate('promptText', defaultParams);
    }

    // if (fee === 0) {
    //     return translate('freeStandingOrderPromptText', {
    //         ...defaultParams,
    //         standingOrderFee: formatMoney(standingOrderRecurranceFee),
    //         accountType: accountRolesLookup[productType],
    //     });
    // } NOTE: This condition is excluded temporarily

    const translationKey = getStandingOrderFeeTranslateKey();

    return translate(translationKey, {
        ...defaultParams,
        standingOrderFee: formatMoney(standingOrderRecurranceFee),
    });
};

export default useTranslatedFeePrompt;